import { render, staticRenderFns } from "./ArchivesStatisticst.vue?vue&type=template&id=e6e71854&scoped=true&"
import script from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
export * from "./ArchivesStatisticst.vue?vue&type=script&lang=js&"
import style0 from "./ArchivesStatisticst.vue?vue&type=style&index=0&id=e6e71854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6e71854",
  null
  
)

export default component.exports